<style>

/* preview styles */
.preview-section {
  border: 1px solid #ededed;
  border-radius: 5px;
  table {
    border-collapse: collapse;
    table-layout: fixed;
    /*width: auto !important;*/
    width: auto;
    tbody {
      counter-reset: row;
      tr:before {
        counter-increment: row;
        content: counter(row);
        display: block;
        position: absolute;
        margin-top: 2px;
        font-size: 10px;
        width: 18px;
        text-align: center;
        color: #555;
      }
      tr.row-worksheet-header {
        border-top: 1px solid #e3e3e3;
        border-bottom: 1px solid #e3e3e3;
      }
      tr {
        td {
          color: #000000;
          height: 18px;
          background-color: transparent;
          /*border-left: 1px solid #e3e3e3;*/
          /*border-right: 1px solid #e3e3e3;*/
          padding: 2px 4px;
          font-family: "Carlito";
          font-size: 12px;
          line-height: 1;
          text-align: right;
          white-space: nowrap;
        }
        td:nth-child(5):has(~td[data-v]) {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      tr.row-worksheet-header td {
        color: #555;
        font-size: 10px;
        text-align: center;
        background-color: #f5f3f3;
      }

      tr.row-worksheet-header:before {
        content: '';
      }
      tr:has(td[data-v="contentIndent0bold"]) td {
        font-weight: bold;
      }
      tr td:first-child {
        background-color: #f5f3f3;
        border-top: 1px solid #e3e3e3;
        padding: 0 10px;
      }
    }
  }
  table:not(#module_cover) {
    td:nth-child(2),
    td:nth-child(3),
    td:nth-child(4),
    td:nth-child(6),
    td:nth-child(7),
    td:nth-child(8) {
      width: 9px;
      min-width: 9px;
      max-width: 9px;
      padding-left: 0;
      padding-right: 0;
      overflow: hidden;
    }
    td:nth-child(5) {
      min-width: 230px;
      max-width: 230px;
      width: 230px;
    }
    td:nth-child(9) {
      text-align: center;
      width: 60px;
      min-width: 60px;
      max-width: 60px;
    }
    td:nth-child(10) {
      text-align: center;
      width: 60px;
      min-width: 60px;
      max-width: 60px;
    }
    td:nth-child(n + 11) {
      width: 80px;
      min-width: 80px;
      max-width: 80px;
      font-size: 12px;
    }
  }
  tr:not(.row-worksheet-header) {
    td:nth-child(2),
    td:nth-child(3),
    td:nth-child(4) {
      color: #fff;
    }
    td:nth-child(5) {
      text-align: left;
    }
  }

  /* hide few first rows */
  table:not(#module_cover) tr:nth-child(-n+3):not(:first-child) {
    //display: none;
  }

  /* cover sheet */
  table#module_cover {
    border-top: 1px solid #DDDDDD;
    border-right: 1px solid #DDDDDD;
    border-bottom: 1px solid #DDDDDD;
    padding-right: 0;
    width: auto !important;
    padding-right: 0;

    tr:not(.row-worksheet-header) {
      border: 1px solid #ffffff;
      background-color: #fff;
      td:not(:first-child) {
        border: none;
        background-color: #fff;
      }
    }
    td:nth-child(2),
    td:nth-child(3) {
      min-width: 20px;
      max-width: 20px;
      width: 20px;
    }

    td:nth-child(4) {
      color: #000 !important;
      text-align: left;
      width: 100%;
    }
    tr.row-worksheet-header {
      td:nth-child(4) {
        text-align: center;
        min-width: 180px;
        max-width: 180px;
      }
      td:nth-child(n+5) {
        min-width: 10px;
        max-width: 10px;
        width: 10px;
      }
    }

    tbody:last-child tr:nth-last-child(-n+8) {
      display: none;
    }
  }
}

#module_assumptions {
  counter-reset: row;
  .col-row-header {
    width: 20px;
    border-bottom: 1px solid #e3e3e3;
  }
  .SectionTable_row:not(.row-worksheet-header) .col-row-header:before {
    counter-increment: row;
    content: counter(row);
    display: block;
    font-size: 10px;
    font-family: Roboto;
    width: 18px;
    text-align: center;
    color: #555;
    padding: 0;
  }
}


/* STYLES */

.preview-section tr:has(td[data-v="sectionDateHeader"]) td:nth-child(n+5) {
  color: #334f77;
  font-weight: bold;
  border-bottom: 2px double #000000;
}

.preview-section tr:has(td[data-v="contentIndent0boldBorderTop"]) td:nth-child(n+5) {
  border-top: 1px solid #000000;
  font-weight: bold;
}

.preview-section tr:has(td[data-v="contentIndent0boldBorderTopDoubleBottom"]) td:nth-child(n+5) {
  border-top: 1px solid #000000;
  border-bottom: 3px double #000000;
  font-weight: bold;
}

.preview-section tr:has(td[data-v="SECTION_HEADER"]) td:nth-child(n+5) {
  background-color: #334f77;
  color: #fff;
  border-left: 1px solid #334f77;
  border-right: 1px solid #334f77;
  font-weight: bold;
  font-size: 12px;
}

.preview-section tr:has(td[data-v="SECTION_HEADER_2"]) td:nth-child(n+5) {
  background-color: #DDDDDD;
  color: #000000;
  border-left: 1px solid #DDDDDD;
  border-right: 1px solid #DDDDDD;
  font-size: 12px;
}

.preview-section tr:has(td[data-v="contentIndent0percentcZero"]) td:nth-child(10) {
  text-align: right;
  position: relative;
  padding-right: 13px;
}
.preview-section tr:has(td[data-v="contentIndent0percentcZero"]) td:nth-child(10):after {
  display: block;
  width: 18px;
  height: 18px;
  content: '%';
  position: absolute;
  right: 2px;
  top: 3px;
}

.preview-section tr:has(td[data-v="contentIndent0"]) td:nth-child(10) {
  text-align: right;
}

.preview-section tr:has(td[data-v="contentIndent1"]) td:nth-child(5) {
  padding-left: 15px;
  overflow: hidden;
}

.preview-section tr:has(td[data-v="contentGrowth0"]) td {
  font-style: italic;
}

.preview-section tr:has(td[data-v="inputIndent0"]) td:nth-child(5) {
  color: #0000FF;
  background-color: #fffbce;
}

.preview-section tr:has(td[data-v="inputIndent1"]) td:nth-child(5),
.preview-section tr:has(td[data-v="inputFcstIndent1"]) td:nth-child(5) {
  padding-left: 15px;
}
.preview-section tr:has(td[data-v="inputIndent1"]) td:nth-child(n+11),
.preview-section tr:has(td[data-v="inputFcstIndent1"]) td:nth-child(n+11),
.preview-section tr:has(td[data-v="inputFcstIndent1BoldName"]) td:nth-child(n+11) {
  color: #0000FF;
  background-color: #fffbce;
}
.preview-section tr:has(td[data-v="inputFcstIndent1BoldName"]) td:nth-child(5) {
  font-weight: bold;
}
.preview-section tr:has(td[data-v="contentIndent1underline"]) td:nth-child(5) {
  padding-left: 15px;
  text-decoration: underline;
}
.preview-section tr:has(td[data-v="inputIndent1NameUnits"]) td:nth-child(5) {
  padding-left: 15px;
}
.preview-section table#module_cover tr:has(td[data-v="model_name"]) td:nth-child(4) {
  font-size: 30px;
  color: #4f6dc8 !important;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.preview-section table#module_cover tr:has(td[data-v="model_name_subheader"]) td:nth-child(4) {
  font-size: 16px;
  color: grey !important;
}
.preview-section table#module_cover tr:has(td[data-v="model_description"]) td:nth-child(4) {
  font-size: 18px;
  font-weight: 500;
  padding-top: 15px;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* end preview styles */

.preview-container {
  display: flex;
  width: 100%;
  justify-content: center;
}

.preview-container.show-borders {
  border: 1px dashed red;
}

.preview-container.show-borders .sheets {
  border: 1px dashed green;
}

table {
  width: 100%;
}
.preview-section td {
  font-size: 14px;
}


.v-input__slot {
  min-height: 35px !important;
}
.v-select__selections {
  padding: 0 !important;
}

.preview-section {
  overflow-x: auto;
  /*padding: 15px 5px 0;*/
  @media (min-width: 1000px) {
    padding: 2px;
    //min-width: 874px;
  }
}

.preview-section .preview-section__html_container {
  opacity: 0;
  transition: opacity 500ms;
  padding: 7px 5px 0;
  @media (min-width: 1000px) {
    padding: 10px;
  }
}

.preview-section_inputs__html_container {
  padding: 7px 5px 0;
  @media (min-width: 1000px) {
    padding: 10px;
  }
}

.preview-section__collapsed {
  table {
    tbody {
      display: block;
    }
    tbody:last-child {
      height: 62px;
      overflow: hidden;
      tr:before {
        display: none;
      }
    }
  }
}

.preview-section.is-initialized .preview-section__html_container {
  opacity: 1;
}

@media (min-width: 1000px) {
  .thumbnails-container {
    display: inherit;
  }
  .sheets_sections {
    padding: 15px 0px 0px 0px;
  }
}

  .preview-section .toggle-rows-btn {
    display: none;
  }

  .preview-section:has(tr:nth-child(77)) .toggle-rows-btn {
    display: block;
  }

  .preview-section__html {
    overflow-y: hidden;
    overflow-x: auto;
  }

  .preview-section__html:not(.rows-expanded) {
    tr:nth-child(n+75):not(:nth-last-child(-n+7)) {
      display: none;
    }
    tr:nth-last-child(-n+7):nth-last-child(n+3):not(:nth-child(-n+74)) {
      display: table-row !important;
      border: none !important;
      &:before {
        content: '' !important;
      }
      td {
        border-top: 1px solid #e0e0e0 !important;
        /*border: none;*/
        color: #fff !important;
        background-color: transparent !important;
        font-size: 1px !important;
        line-height: 1px;
        padding: 0;
        height: 3px;
      }
    }
  }

.sheets {
  /*flex: 1 1 0;*/
  display: flex;
  gap: 50px;
  padding-bottom: 250px;
  position: relative;
  width: 100%;
  @media (min-width: 1000px) {
    width: auto;
    /*width: calc(100% - 400px);*/
    max-width: 1000px;
  }
}

.sheets_sections {
  flex: 1 1 0;
  padding: 0;
  width: 100%;
}
</style>


<template>
  <div
    class="preview-container"
    :class="showBorders && 'show-borders'"
    style="gap: 50px;"
  >
    <TemplatePreviewThumbnails/>
    <div class="sheets">
      <div class="sheets_sections">
        <TemplateToolbar
          v-if="$store.state.mode === 'static'"
          :downloadOptions="$store.state.activeTemplate.copy && $store.state.activeTemplate.copy.downloadOptions"
          style="margin-bottom: 30px;"
        />
        <div v-if="$store.state.activeTemplate.isLocked" style="text-align: center; color: red;">*** LOCKED ***</div>
        <div
          v-for="(previewModule) in modules"
          :key="previewModule.id"
          style="margin-bottom: 50px; position: relative;"
          :style="previewModule.id === 'module_cover' ? 'padding-top: 40px' : ''"
          :data-testid="previewModule.id"
        >
          <TemplateSectionToolbarEditToggle
            v-if="previewModule.templateSectionCfg"
            :moduleOrSection="previewModule"
          />

          <div
            v-if="!previewModule.mappedToSection || previewModule.mappedToSection.isEnabled"
            style="position:relative;"
          >
            <div
              v-if="previewModule.isInitialized === true && (!previewModule.mappedToSection || previewModule.mappedToSection.isEnabled)"
              style="position: absolute; top: -22px; left: 20px; font-size: 12px; line-height: 1; background-color: transparent;
                        padding: 6px 10px; border-top-left-radius: 7px; border-top-right-radius: 7px;">
              <strong>{{ translate(previewModule.id) }}</strong> {{ translate('ui_sheet') }}
            </div>

            <div v-if="previewModule.id === 'module_cover'">
              <TemplateSectionToolbarEditToggle
                  :moduleOrSection="previewModule"
              />
            </div>
            <div
              :id="previewModule.id"
              class="section-container preview-section"
              :class="previewModule.isInitialized ? 'is-initialized' : ''"
            >
              <v-progress-linear
                  v-show="isUpdating(previewModule)"
                  color="deep-purple accent-4"
                  indeterminate
                  rounded
                  height="1"
                  style="position: absolute; top: 0; left: 0;"
              ></v-progress-linear>
              <v-btn
                  class="toggle-rows-btn"
                  x-small
                  fab
                  style="position: absolute; bottom: 52px; left: 10px; z-index: 1;"
                  @click="toggleRows(previewModule)"
                  color="primary"
              >
                <v-icon
                    color="white">mdi-arrow-expand-all
                </v-icon>
              </v-btn>

              <div
                  v-if="previewModule.id === 'module_assumptions'"
                  :data-id="previewModule.id"
                  class="preview-section_inputs__html_container"
              >
                <div
                    v-if="!previewModule.isInitialized"
                    style="display: flex; align-items: center; gap: 10px;"
                >
                  <v-progress-circular
                      :size="10"
                      :width="1"
                      indeterminate
                  ></v-progress-circular>
                  <v-icon>
                    {{ previewModule.icon ? previewModule.icon : 'mdi-table' }}
                  </v-icon>
                  {{ translate(previewModule.longName || previewModule.id) }}
                </div>

                <div v-if="previewModule.isInitialized">
                  <TemplateSectionGeneral/>
                </div>

              </div>

              <div
                v-if="previewModule.id !== 'module_assumptions'"
                :class="previewModule.previewCfg.isRowsExpanded && 'rows-expanded'"
                class="preview-section__html"
              >
                <TemplateSectionToolbar v-if="previewModule.templateSectionCfg" :previewModule="previewModule"/>

                <div
                  v-if="previewModule.templateSectionCfg && getSectionById(previewModule.templateSectionCfg.id).sectionResources && getSectionById(previewModule.templateSectionCfg.id).isEditingSettings"
                  style="padding: 15px 0;"
                >
                  <TemplateSection
                    :section="getSectionById(previewModule.templateSectionCfg.id)"
                  >
                    <template v-slot:table-container__content>
                      <TemplateSectionCenterResourceGroup
                        :sectionId="previewModule.templateSectionCfg.id"
                        :showResourceSelector="true"
                      />
                    </template>
                  </TemplateSection>
                </div>

                <div
                  v-if="previewModule.isInitialized === 'queued' || previewModule.isInitialized === 'progress'"
                  style="display: flex; align-items: center; gap: 10px; padding: 10px 25px; max-width: 90%; width: 500px;"
                >
                  <v-progress-circular
                    :size="10"
                    :width="1"
                    indeterminate
                  ></v-progress-circular>
                  <v-icon>
                    {{ previewModule.icon ? previewModule.icon : 'mdi-table' }}
                  </v-icon>
                  {{ translate(previewModule.longName || previewModule.id) }}
                </div>

                <div
                  v-if="shouldShowPreviewHTML(previewModule)"
                  class="preview-section__html_container"
                  @click="editModuleOrSection(previewModule)"
                  :title="getTitle(previewModule)"
                  v-html="getModuleById(previewModule.id).previewCfg.previewHTML"
                  :class="previewModule.templateSectionCfg && getSectionById(previewModule.templateSectionCfg.id).isCollapsed ? 'preview-section__collapsed' : ''"
                  :style="showCursorPointer(previewModule) && 'cursor: pointer'"
                >
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TemplateSection from '@/components/sections/TemplateSection';
import TemplateSectionCenterResourceGroup
  from '@/components/sections/TemplateSection/TemplateSectionCenterResourceGroup.vue';
import TemplateSectionGeneral from '@/components/sections/TemplateSectionGeneral';
import TemplateSectionToolbar from '@/components/sections/TemplateSectionToolbar.vue';
import TemplateSectionToolbarEditToggle from '@/components/sections/TemplateSectionEditToggle';
import TemplatePreviewThumbnails from '@/pages/Template/TemplatePreviewThumbnails';
import TemplateToolbar from '@/pages/Template/TemplateToolbar';
import Mixin from '@/mixins/mixin';

export default {
  name: 'TemplatePreviewModules',
  components: {
    TemplateToolbar,
    TemplateSection,
    TemplateSectionCenterResourceGroup,
    TemplateSectionGeneral,
    TemplateSectionToolbar,
    TemplateSectionToolbarEditToggle,
    TemplatePreviewThumbnails,
  },
  mixins: [Mixin],
  data: () => ({
    showBorders: false,
  }),
  props: {},
  computed: {
    modules() {
      const { modules } = this.$store.state.activeTemplate.data;
      const result = modules.reduce((arr, module) => {
        if (module.isEnabled && !module.hideInEditor) {
          const mappedToSection = module.mappedToSectionId && this.getSectionById(module.mappedToSectionId);
          if (mappedToSection) {
            // eslint-disable-next-line
            module.mappedToSection = mappedToSection;
            // eslint-disable-next-line
            module.isDisabling = mappedToSection.isDisabling;
            // eslint-disable-next-line
            module.isEnabled = mappedToSection.isEnabled;
            arr.push(module);
          } else {
            arr.push(module);
          }
        }
        return arr;
      }, []);
      return result;
    },
  },
  methods: {
    isUpdating(module) {
      return this.$store.state.activeTemplate.data.modules.find((m) => m.id === module.id).previewCfg.isUpdating;
    },
    showCursorPointer(previewModule) {
      return previewModule.templateSectionCfg || previewModule.id === 'module_cover' || previewModule.id === 'section_timeline';
    },
    sectionName(module) {
      // const module = this.$store.state.previewModules.find((sect) => sect.mappedToSection && sect.mappedToSection.id === section.id);
      return this.translate(module ? module.id : module.templateSectionCfg.title);
    },
    getTitle(module) {
      const editableSections = [
        'module_cover',
        'section_timeline',
        'module_revenue',
        'module_sga',
        'module_wc',
        'module_fixedassets',
        'module_financing',
        'module_ip',
      ];

      const result = editableSections.includes(module.id) ? `${this.translate('ui_dialog_edit')} ${this.sectionName(module)} ${this.translate('ui_module_settings')}` : '';
      return result;
    },
    shouldShowPreviewHTML(module) {
      /*
      console.log(module);
      return true;
            */
      const alwaysVisibleForModulesWithSections = ['module_wc', 'module_ip'];
      const mappedToSection = module.templateSectionCfg && this.getSectionById(module.templateSectionCfg.id);
      return module.isInitialized === true
        && module.isEnabled
        && (alwaysVisibleForModulesWithSections.includes(module.id) || !mappedToSection || (mappedToSection && !mappedToSection.isEditingSettings));


      // const alwaysVisibleForSections = ['section_npv', 'section_wc'];
      // const isVisible = previewModule.isInitialized
      //   && (!previewModule.mappedToSection || alwaysVisibleForSections.includes(previewModule.mappedToSection.id) || !previewModule.mappedToSection.isEditingSettings);
      // const isVisible = (!module.mappedToSection || alwaysVisibleForSections.includes(module.mappedToSection.id) || !module.mappedToSection.isEditingSettings);
      // return isVisible && module.previewCfg.previewHTML;
    },
    toggleRows(section) {
      const previewedModule = this.$store.state.activeTemplate.data.modules.find((module) => module.id === section.id);
      previewedModule.previewCfg.isRowsExpanded = !previewedModule.previewCfg.isRowsExpanded;
    },
  },
  watch: {},
};
</script>
